var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestResultsPercent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45778 15.9169L15.0844 4.39508M4.18667 7.28435C4.76661 7.28435 5.32279 7.05605 5.73287 6.64967C6.14295 6.24328 6.37333 5.69211 6.37333 5.1174C6.37333 4.54268 6.14295 3.99151 5.73287 3.58513C5.32279 3.17874 4.76661 2.95044 4.18667 2.95044C3.60673 2.95044 3.05054 3.17874 2.64046 3.58513C2.23038 3.99151 2 4.54268 2 5.1174C2 5.69211 2.23038 6.24328 2.64046 6.64967C3.05054 7.05605 3.60673 7.28435 4.18667 7.28435ZM15.8133 17.3616C16.3933 17.3616 16.9495 17.1333 17.3595 16.7269C17.7696 16.3205 18 15.7693 18 15.1946C18 14.6199 17.7696 14.0687 17.3595 13.6623C16.9495 13.256 16.3933 13.0277 15.8133 13.0277C15.2334 13.0277 14.6772 13.256 14.2671 13.6623C13.857 14.0687 13.6267 14.6199 13.6267 15.1946C13.6267 15.7693 13.857 16.3205 14.2671 16.7269C14.6772 17.1333 15.2334 17.3616 15.8133 17.3616Z",
    stroke: "currentColor",
    strokeWidth: 0.95225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestResultsPercent);
export default ForwardRef;